@if (sentence) {
<div class="summary">
  <p class="summary-text">
    <mat-icon>{{ isDate ? 'schedule' : 'filter_alt' }}</mat-icon>
    {{ sentence }}
  </p>

  <!-- Today, what the date filter keeps of it: the kept hours in color, the time after now hatched -->
  @if (isDate) {
  <div class="day">
    <span class="day-label">{{ 'editor.filter_summary.today' | translate }}</span>
    <div class="day-track">
      <span class="day-future" [style.left.%]="nowPercent"></span>
      @for (segment of segments; track $index) {
      <span class="day-kept" [style.left.%]="segment.from" [style.width.%]="segment.to - segment.from"></span>
      }
      <span class="day-now" [style.left.%]="nowPercent"></span>
    </div>
    <div class="day-ticks">
      @for (tick of ticks; track tick) {
      <span>{{ tick }}h</span>
      }
    </div>
  </div>
  }
</div>
}
